export const brandColours = {
  white: "#FFFFFF",
  black: "#000000",
  gold: "#A18B6B",
};
